<template>
  <el-table
    v-loading="loading"
    :data="avaliations"
    class="table-responsive table-striped"
    header-row-class-name="thead-light"
    style="width: 100%;"
  >
    <el-table-column label="Nome" prop="name" />
    <el-table-column label="Período" prop="participation_ppr_description" />
    <el-table-column label="Qtd. respostas" prop="response_count" width="180px" v-slot="{ row }">
      {{ row.response_count.toLocaleString('pt-BR') }}
    </el-table-column>
    <el-table-column label="Ultima resposta" prop="last_response_date" width="180px" v-slot="{ row }">
      {{ row.last_response_date | formatDate }}
    </el-table-column>
    <el-table-column label="Data de inicio" width="180px" prop="start_date" v-slot="{ row }"  >
      {{ row.created_at | formatDate }}
    </el-table-column>

    <!-- v-if="$can('update', 'avaliation') || $can('destroy', 'avaliation')" -->
    <el-table-column
      label="Ações"
      width="80px"
      prop="acoes"
      v-slot="{ row }"
    >
      <el-dropdown
        class="dropdown"
        style="cursor: pointer;"
      >
        <span class="btn btn-sm btn-icon-only text-success">
          <i class="fas fa-ellipsis-v mt-2"></i>
        </span>
        <el-dropdown-menu
          class="dropdown-menu dropdown-menu-arrow show"
          slot="dropdown"
        >
          <a class="dropdown-item" href="#" @click="$emit('action:show:avaliation',    row)">Ver Resultados</a>
          <a class="dropdown-item" href="#" @click="$emit('action:respond:avaliation', row)">Responder</a>
          <a class="dropdown-item" href="#" @click="$emit('action:edit:avaliation',    row)">Editar</a>
          <a class="dropdown-item" href="#" @click="$emit('action:destroy:avaliation', row)">Excluir</a>
        </el-dropdown-menu>
      </el-dropdown>
    </el-table-column>
  </el-table>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  Dropdown,
} from "element-ui";

export default {
  name: 'AvaliationList',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
  },
  props: {
    avaliations: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
